import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import Header from "./header";
import TableMain from "./content/table";
import ImagePage from "./content/images_page";
import api from "../../api/api";

const Report = () => {
    const [chooseDistipline, setChooseDistiplines] = useState(null)
    const [ageGroupSelect, setAgeGroupSelect] = useState(null)
    const [choosePage, setChoosePage] = useState(1)
    const [currentTimeZoneId, setCurrentTimeZoneId] = useState(null);

    useEffect(() => {
        const getTimezones = async () => {
            const res = await api().get('/timezones/list');
            setCurrentTimeZoneId(res?.data?.current_id);
        }

        getTimezones().then();
    }, [choosePage]);

    return (
        <div>
            <Header ageGroupSelect={ageGroupSelect} setAgeGroupSelect={setAgeGroupSelect}
                    chooseDistipline={chooseDistipline} setChooseDistiplines={setChooseDistiplines}/>

            <div className={s.navigate} style={{
                gridTemplateColumns: `repeat(2,1fr)`
            }}>
                <div className={s.line} style={{
                    width: `calc(100% / 2)`,
                    left: `${(100 / 2) * (choosePage - 1)}%`
                }}/>
                <div onClick={() => setChoosePage(1)} className={s.navigate_item}>Отчеты</div>
                <div onClick={() => setChoosePage(2)} className={s.navigate_item}>Настройки</div>
            </div>
            {(ageGroupSelect !== null && chooseDistipline !== null) || choosePage !== 1 ?
                <div className={s.content}>
                    <div style={{display: choosePage === 1 ? 'block' : 'none'}}>
                        <TableMain
                            ageGroupSelect={ageGroupSelect}
                            chooseDistipline={chooseDistipline}
                            currentTimeZoneId={currentTimeZoneId}
                        />
                    </div>

                    <div style={{display: choosePage === 2 ? 'block' : 'none'}}>
                        <ImagePage
                            ageGroupSelect={ageGroupSelect}
                            chooseDistipline={chooseDistipline}
                        />
                    </div>
                </div> :
                <h1 className={s.empty}>Выберите возрастную группу и дисциплину</h1>}
        </div>
    );
};

export default Report;